import { inheritsLoose as _inheritsLoose, objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

var _excluded = ["className", "children", "role"];
var ToggleBarSection = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(ToggleBarSection, _React$PureComponent);
  function ToggleBarSection() {
    return _React$PureComponent.apply(this, arguments) || this;
  }
  var _proto = ToggleBarSection.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      className = _this$props.className,
      children = _this$props.children,
      role = _this$props.role,
      args = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/React.createElement("div", _extends({
      className: cx(className, 'btn-toolbar'),
      role: role
    }, args), children);
  };
  return ToggleBarSection;
}(React.PureComponent);
ToggleBarSection.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * The ARIA role describing the button toolbar. Generally the default
   * "toolbar" role is correct. An `aria-label` or `aria-labelledby`
   * prop is also recommended.
   */
  role: PropTypes.string
};
ToggleBarSection.defaultProps = {
  role: 'toolbar'
};

export { ToggleBarSection as default };
//# sourceMappingURL=Section.js.map
